import request from '@/utils/request'
import API from '@/api/index.js'

// 登录方法
export function dwLogin (params) {
  // const params = {userName, password, type: 'account'}
  return request({
    url: API.loginIn,
    method: 'post',
    params
  })
}

// 登录方法
export function feishuLogin (params) {
  // const params = {userName, password, type: 'account'}
  return request({
    url: API.feishuLogin,
    method: 'post',
    params
  })
}

export function wxLoginTicket (params) {
  return request({
    url: API.loginWxQrCode,
    method: 'post',
    params
  })
}

export function wxLoginTicketStatus (params) {
  return request({
    url: API.loginWxStatus,
    method: 'post',
    params
  })
}

export function sendFakeCaptcha (params) {
  return request({
    url: API.loginSendSms,
    method: 'post',
    params
  })
}

// 退出方法
export function logout () {
  // token方案
  // DwAuthorized.setToken('')
  // session方案
  return request({
    url: API.logOut,
    method: 'post'
  })
}

// 登录方法
export function dwRegister (params) {
  // const params = {userName, password, type: 'account'}
  return request({
    url: API.register,
    method: 'post',
    params
  })
}

export function answerLoginSurveyInfo (sid) {
  const params = {sid}
  return request({
    url: '/api/dwsurvey/anon/response/survey_info.do',
    method: 'post',
    params
  })
}

export function verifiedCaptchaCode (params) {
  return request({
    url: '/api/dwsurvey/anon/jcap/jcaptcha-check.do',
    method: 'post',
    params
  })
}




// WEBPACK FOOTER //
// ./src/api/dw-login.js